"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            stats: null,
            sales: null,
            more: false,
            fetching: false,
            suggestions: [],
            defaultManager: null
        };
        this.hasManager();
        this.fetchStats();
        this.fetchSales();
    },
    onDisplaySale: function ({__manager, __id}) {
        window.Extensions.run(__manager, {
            action: 'view:transaction',
            id: __id
        });
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({saleId, status, entity, payment, made}) => {
            return {
                poster: {
                    type: 'image',
                    value: payment.portal.favicon
                },
                title: entity.label || entity.name,
                subtitle: made.by,
                status,
                manager: payment.manager,
                saleId
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
        const {manager, saleId} = this.state.suggestions[index];
        this.onDisplaySale(manager, saleId);
    },
    fetchStats: async function () {
        try {
            const {error, message, stats} = await Request('/sales/stats');
            if (error)
                throw new Error(message);
            this.state.stats = stats;
        } catch (error) {
            console.log('Error Fetching Sales Stat: ', error);
        }
    },
    fetchSales: async function () {
        this.state.fetching = true;
        try {
            const {error, message, sales, more} = await Request(this.state.more || '/sales/list');
            if (error)
                throw new Error(message);
            if (more) {
                this.state.more = more;
                this.sales = [
                    ...this.sales,
                    ...sales
                ];
            } else
                this.sales = sales;
            this.state.sales = this.sales.map(({saleId, status, entity, payment, items, made}) => {
                let itemsList = '';
                items.map(({name, price, currency, count}) => {
                    itemsList += `<li>${ name } (${ count || 1 }) - ${ price } ${ payment.currency }`;
                });
                const {photo, first_name, last_name, email} = made.by && made.by.profile || {};
                return {
                    type: entity.name.toCapitalCase(),
                    status,
                    portal: `<img src=${ payment.portal.favicon } width=30 class="rounded"/>`,
                    transaction: payment.transaction || payment.reference,
                    items: `<ul class="list-unstyled">${ itemsList }</ul>`,
                    by: `<img src=${ photo } width=38 class="float-left rounded mr-4"/><div><span>${ first_name } ${ last_name }</span><br> <span class="font-small-3 text-muted">${ email }</span></div>`,
                    datetime: formatDate(made.at, 'calendar'),
                    __manager: payment.manager,
                    __id: saleId
                };
            });
        } catch (error) {
            console.log('Error Fetching Sales: ', error);
        }
        this.state.fetching = false;
    },
    hasManager: async function () {
        try {
            const {error, message, results} = await Request(`/extension/search?query=payment-manager`);
            if (error)
                throw new Error(message);
            if (results && results.length)
                this.state.defaultManager = results[0];
        } catch (error) {
            console.log('Error Searching App: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/BillPayment/Admin/Sales.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    SearchBar_template = require("../../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    Datatable_template = require("../../../components/Datatable/index.marko"),
    Datatable_tag = marko_loadTag(Datatable_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("0bdb9c"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("img", {
        src: "/images/illustration/sales.png",
        "class": "w-75 img-fluid",
        alt: "illustration"
      }, "22", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "py-1"
      },
    marko_attrs3 = {
        "class": "py-1"
      },
    marko_attrs4 = {
        "class": "text-muted"
      },
    marko_attrs5 = {
        "class": "mt-1"
      },
    marko_node6 = marko_createElement("span", {
        "class": "font-medium-1 text-muted"
      }, "29", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("GHc"),
    marko_attrs6 = {
        "class": "px-50"
      },
    marko_attrs7 = {
        "class": "col-12"
      },
    marko_node7 = marko_createElement("br", null, "37", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("br", null, "38", null, 0, 0, {
        i: marko_const_nextId()
      });

const tableFormat = [
	{ key: 'portal', label: 'Portal', col: '1' },
	{ key: 'type', label: 'Type', col: '1' },
	{ key: 'items', label: 'Items' },
	{ key: 'by', label: 'By', col: '3' },
	{ key: 'status', label: 'Status', col: '1', style: 'text-primary' },
	{ key: 'transaction', label: 'Reference', col: '1', style: 'text-warning' },
	{ key: 'datetime', label: 'Date & Time', col: '2', wsadapt: { qs: 'd-none', hs: 'd-none' } }
];

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out) {
        if (state.sales === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!state.sales.length) {
          out.be("div", marko_attrs0, "2", component);

          Row_tag({
              class: "m-0 w-100 d-flex align-items-center",
              renderBody: function(out) {
                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      out.be("h5", null, "5", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Manage your sales");
                          }
                        }, out, __component, "6");

                      out.ee();

                      out.n(marko_node0, component);

                      out.be("p", marko_attrs1, "8", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Here you control your sales and the various payment managers that facilitate payment on your plateform. For more payment managers go to our");
                          }
                        }, out, __component, "9");

                      out.t(" ");

                      route_link_tag({
                          href: "/marketplace/#apps/payment-manager",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Marketplace"
                              }, out, __component, "11");
                          }
                        }, out, __component, "10");

                      out.ee();

                      out.n(marko_node1, component);

                      route_link_tag({
                          class: "btn btn-primary btn-lg m-25",
                          href: "/payment-managers",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Payment Managers"
                              }, out, __component, "14");
                          }
                        }, out, __component, "13");

                      out.n(marko_node2, component);

                      out.n(marko_node3, component);

                      out.n(marko_node4, component);

                      route_link_tag({
                          class: "d-flex align-items-center font-medium-2",
                          href: "/help/sales",
                          renderBody: function(out) {
                            Locale_tag({
                                renderBody: function(out) {
                                  out.t("Click here for more information");
                                }
                              }, out, __component, "19");

                            Bx_tag({
                                type: "right-arrow-alt",
                                class: "ml-2 font-medium-5"
                              }, out, __component, "20");
                          }
                        }, out, __component, "18");
                    }
                  }, out, __component, "4");

                WSAdapt_tag({
                    class: "col text-center",
                    renderBody: function(out) {
                      out.n(marko_node5, component);
                    }
                  }, out, __component, "21");
              }
            }, out, __component, "3");

          out.ee();
        } else {
          if (state.stats) {
            out.be("section", marko_attrs3, "23", component);

            Row_tag({
                class: "m-0",
                col: [
                    {
                        ns: "col-3",
                        renderBody: function(out) {
                          out.be("p", marko_attrs4, "26", component);

                          Locale_tag({
                              text: "Earnings"
                            }, out, __component, "27");

                          out.ee();

                          out.e("h1", marko_attrs5, "28", component, 2)
                            .n(marko_node6, component)
                            .e("span", marko_attrs6, "30", component, 1)
                              .t(state.stats.net, component);
                        }
                      }
                  ]
              }, out, __component, "24");

            out.ee();
          }

          out.be("section", marko_attrs2, "31", component);

          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                WSAdapt_tag({
                    ns: "col-5",
                    qs: "col-7",
                    hs: "col-7",
                    renderBody: function(out) {
                      SearchBar_tag({
                          icon: "bx-search",
                          target: "sales",
                          minLength: 3,
                          suggestions: state.suggestions,
                          placeholder: Locale("Find a Sale")
                        }, out, __component, "34", [
                        [
                          "blur",
                          "onSearchDismiss",
                          false
                        ],
                        [
                          "result",
                          "onSearchResult",
                          false
                        ],
                        [
                          "select",
                          "onSelectSuggestion",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "33");

                WSAdapt_tag({
                    class: "col"
                  }, out, __component, "35");

                out.be("div", marko_attrs7, "36", component);

                out.n(marko_node7, component);

                out.n(marko_node8, component);

                Datatable_tag({
                    format: tableFormat,
                    data: state.sales,
                    pagination: 10,
                    stripped: true,
                    loading: state.fetching,
                    class: "w-100"
                  }, out, __component, "39", [
                  [
                    "canload",
                    "fetchSales",
                    false
                  ],
                  [
                    "select",
                    "onDisplaySale",
                    false
                  ]
                ]);

                out.ee();
              }
            }, out, __component, "32");

          out.ee();
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
